import { useCallback } from 'react';
import { vsTrash } from '@deephaven/icons';
import { ActionButtonDialogTrigger, ConfirmationDialog } from "../dialogs/index.js";
import { ACTION_ICON_HEIGHT } from "../UIConstants.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ConfirmActionButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    heading = _ref.heading,
    confirmationButtonLabel = _ref.confirmationButtonLabel,
    isHidden = _ref.isHidden,
    children = _ref.children,
    tooltip = _ref.tooltip,
    _onConfirm = _ref.onConfirm;
  var renderDialog = useCallback(close => /*#__PURE__*/_jsx(ConfirmationDialog, {
    heading: heading,
    confirmationButtonLabel: confirmationButtonLabel,
    onCancel: close,
    onConfirm: () => {
      close();
      _onConfirm();
    },
    children: children
  }), [children, confirmationButtonLabel, heading, _onConfirm]);
  return /*#__PURE__*/_jsx(ActionButtonDialogTrigger, {
    ariaLabel: ariaLabel,
    icon: vsTrash,
    isHidden: isHidden,
    isQuiet: true,
    height: ACTION_ICON_HEIGHT,
    tooltip: tooltip,
    children: renderDialog
  });
}
export default ConfirmActionButton;
//# sourceMappingURL=ConfirmActionButton.js.map